/**
 * @generated SignedSource<<82e9b83f2b63aff8cc35edcac0d10478>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type useSocialSignUpAcceptInvitationMutation$variables = {
  invitationId: string;
};
export type useSocialSignUpAcceptInvitationMutation$data = {
  readonly createUser: {
    readonly __typename: "ForbiddenError";
    readonly reason: string;
  } | {
    readonly __typename: "NotFoundError";
    readonly reason: string;
  } | {
    readonly __typename: "UserCreated";
    readonly uid: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type useSocialSignUpAcceptInvitationMutation = {
  response: useSocialSignUpAcceptInvitationMutation$data;
  variables: useSocialSignUpAcceptInvitationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "invitationId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reason",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": "createUser",
    "args": [
      {
        "kind": "Variable",
        "name": "invitationId",
        "variableName": "invitationId"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "acceptInvitation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uid",
            "storageKey": null
          }
        ],
        "type": "UserCreated",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "ForbiddenError",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "NotFoundError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSocialSignUpAcceptInvitationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSocialSignUpAcceptInvitationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c75c0058860d50e43c3475ec43c8673a",
    "id": null,
    "metadata": {},
    "name": "useSocialSignUpAcceptInvitationMutation",
    "operationKind": "mutation",
    "text": "mutation useSocialSignUpAcceptInvitationMutation(\n  $invitationId: ID!\n) {\n  createUser: acceptInvitation(invitationId: $invitationId) {\n    __typename\n    ... on UserCreated {\n      uid\n    }\n    ... on ForbiddenError {\n      reason\n    }\n    ... on NotFoundError {\n      reason\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a6822a3d619228c5a6794d726e8f2eb";

export default node;
